import { dossiers } from '@/mocks/dossiers';
import Reveal from '@/components/base/Reveal';

export default function DossierSection() {
  return (
    <section id="dossiers" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-7xl">
        <Reveal className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-[11px] tracking-[0.24em] text-primary-600">
              DOSSIERS / 条线档案
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              把零散帖子，整理成能读完的一条线
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            每份档案对应一条深夜黑料争议线，从起点、关键时间到最终结果连起来，图片与文字一起看更清楚。
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {dossiers.map((item, index) => (
            <Reveal key={item.id} delay={(index % 3) * 90}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="relative h-44 w-full overflow-hidden md:h-48">
                  <img
                    src={item.image}
                    alt={`${item.title} ${item.subtitle} 深夜黑料条线档案`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
                  <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-1 font-label text-[10px] tracking-[0.14em] text-background-50 backdrop-blur">
                    {item.count} 条
                  </span>
                  <div className="absolute bottom-3 left-3 right-3 flex flex-wrap gap-1.5">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-background-50/90 px-2 py-0.5 text-[11px] text-foreground-800"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs font-medium text-primary-600">{item.subtitle}</p>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-4">
                    <span className="font-label text-[11px] text-foreground-400">
                      更新 {item.updated}
                    </span>
                    <span className="flex items-center gap-1 text-xs font-medium text-primary-600 transition-transform group-hover:translate-x-0.5">
                      查看档案
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}